"use client";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import React from "react";

export default function Custom404() {
  const t = useTranslations();
  const router = useRouter();
  return (
    <div className="flex h-screen md:pt-20 md:items-start items-center gap-5 md:gap-0 justify-center bg-[#FAFAFA] md:bg-[#F5F5F5]">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center md:max-h-[657px] p-8 md:p-20 bg-[#FAFAFA] rounded-xl md:shadow-md ">
        <div className="flex flex-col md:items-start items-center md:justify-center w-full gap-4">
          <h1 className="md:text-[40px] text-[30px] font-bold">
            {t("notFound.oops")}
          </h1>
          <p className="md:text-[32px] text-[20px]">{t("notFound.title")}</p>
          <p className=" text-[#4B4B4B] md:text-[16px] text-center md:text-left">
            {t("notFound.description1")} <br />
            {t("notFound.description2")}
          </p>
          <div
            onClick={() => router.replace("/")}
            className="px-4 cursor-pointer w-fit mt-5 py-2 bg-black text-white rounded-lg hover:bg-gray-800"
          >
            <img
              src="/assets/arrow-left-white.svg"
              alt="home icon"
              className="inline mr-2"
            />

            {t("notFound.buttonText")}
          </div>
        </div>

        <div className="flex order-first md:order-2 justify-center items-center md:mt-8">
          <img
            src="/assets/not-found.svg"
            alt="404 illustration"
            className="w-[262px] h-[192px] md:w-[518px] md:h-[379px]"
          />
        </div>
      </div>
    </div>
  );
}
